import React from "react";
import {MdOutlinePublic} from "react-icons/md";
import {useRouter} from "next/router";
import {Button} from "@varymadellc/my-weed-club-component-library";

export default function EventsPastPageMenu() {
    const router = useRouter();

    return (
        <div className="flex flex-row gap-4">
             <Button onClick={() => router.push('/events')} className="flex flex-row gap-2 items-center">
                 <>
                     <MdOutlinePublic/>
                     <span>Show Upcoming Events</span>
                 </>
             </Button>
        </div>
    );
}